// src/data/countries.js
// Полный список стран по ISO 3166-1 alpha-2.
// Сортируется по русскому названию в момент использования.

export const COUNTRIES = [
  { code: 'AU', name: 'Австралия',           flag: '🇦🇺', currency: 'AUD' },
  { code: 'AT', name: 'Австрия',             flag: '🇦🇹', currency: 'EUR' },
  { code: 'AZ', name: 'Азербайджан',         flag: '🇦🇿', currency: 'AZN' },
  { code: 'AL', name: 'Албания',             flag: '🇦🇱', currency: 'EUR' },
  { code: 'DZ', name: 'Алжир',               flag: '🇩🇿', currency: 'USD' },
  { code: 'AO', name: 'Ангола',              flag: '🇦🇴', currency: 'USD' },
  { code: 'AD', name: 'Андорра',             flag: '🇦🇩', currency: 'EUR' },
  { code: 'AG', name: 'Антигуа и Барбуда',   flag: '🇦🇬', currency: 'USD' },
  { code: 'AR', name: 'Аргентина',           flag: '🇦🇷', currency: 'ARS' },
  { code: 'AM', name: 'Армения',             flag: '🇦🇲', currency: 'AMD' },
  { code: 'AF', name: 'Афганистан',          flag: '🇦🇫', currency: 'AFN' },
  { code: 'BS', name: 'Багамы',              flag: '🇧🇸', currency: 'USD' },
  { code: 'BD', name: 'Бангладеш',           flag: '🇧🇩', currency: 'INR' },
  { code: 'BB', name: 'Барбадос',            flag: '🇧🇧', currency: 'USD' },
  { code: 'BH', name: 'Бахрейн',             flag: '🇧🇭', currency: 'USD' },
  { code: 'BY', name: 'Беларусь',            flag: '🇧🇾', currency: 'BYN' },
  { code: 'BZ', name: 'Белиз',               flag: '🇧🇿', currency: 'USD' },
  { code: 'BE', name: 'Бельгия',             flag: '🇧🇪', currency: 'EUR' },
  { code: 'BJ', name: 'Бенин',               flag: '🇧🇯', currency: 'USD' },
  { code: 'BG', name: 'Болгария',            flag: '🇧🇬', currency: 'BGN' },
  { code: 'BO', name: 'Боливия',             flag: '🇧🇴', currency: 'USD' },
  { code: 'BA', name: 'Босния и Герцеговина',flag: '🇧🇦', currency: 'EUR' },
  { code: 'BW', name: 'Ботсвана',            flag: '🇧🇼', currency: 'USD' },
  { code: 'BR', name: 'Бразилия',            flag: '🇧🇷', currency: 'BRL' },
  { code: 'BN', name: 'Бруней',              flag: '🇧🇳', currency: 'USD' },
  { code: 'BF', name: 'Буркина-Фасо',        flag: '🇧🇫', currency: 'USD' },
  { code: 'BI', name: 'Бурунди',             flag: '🇧🇮', currency: 'USD' },
  { code: 'BT', name: 'Бутан',               flag: '🇧🇹', currency: 'INR' },
  { code: 'VU', name: 'Вануату',             flag: '🇻🇺', currency: 'USD' },
  { code: 'GB', name: 'Великобритания',      flag: '🇬🇧', currency: 'GBP' },
  { code: 'HU', name: 'Венгрия',             flag: '🇭🇺', currency: 'HUF' },
  { code: 'VE', name: 'Венесуэла',           flag: '🇻🇪', currency: 'USD' },
  { code: 'TL', name: 'Восточный Тимор',     flag: '🇹🇱', currency: 'USD' },
  { code: 'VN', name: 'Вьетнам',             flag: '🇻🇳', currency: 'USD' },
  { code: 'GA', name: 'Габон',               flag: '🇬🇦', currency: 'USD' },
  { code: 'HT', name: 'Гаити',               flag: '🇭🇹', currency: 'USD' },
  { code: 'GY', name: 'Гайана',              flag: '🇬🇾', currency: 'USD' },
  { code: 'GM', name: 'Гамбия',              flag: '🇬🇲', currency: 'USD' },
  { code: 'GH', name: 'Гана',                flag: '🇬🇭', currency: 'USD' },
  { code: 'GP', name: 'Гваделупа',           flag: '🇬🇵', currency: 'USD' },
  { code: 'GT', name: 'Гватемала',           flag: '🇬🇹', currency: 'USD' },
  { code: 'GN', name: 'Гвинея',              flag: '🇬🇳', currency: 'USD' },
  { code: 'GW', name: 'Гвинея-Бисау',        flag: '🇬🇼', currency: 'USD' },
  { code: 'DE', name: 'Германия',            flag: '🇩🇪', currency: 'EUR' },
  { code: 'HN', name: 'Гондурас',            flag: '🇭🇳', currency: 'USD' },
  { code: 'HK', name: 'Гонконг',             flag: '🇭🇰', currency: 'HKD' },
  { code: 'GD', name: 'Гренада',             flag: '🇬🇩', currency: 'USD' },
  { code: 'GR', name: 'Греция',              flag: '🇬🇷', currency: 'EUR' },
  { code: 'GE', name: 'Грузия',              flag: '🇬🇪', currency: 'GEL' },
  { code: 'DK', name: 'Дания',               flag: '🇩🇰', currency: 'DKK' },
  { code: 'DJ', name: 'Джибути',             flag: '🇩🇯', currency: 'USD' },
  { code: 'DM', name: 'Доминика',            flag: '🇩🇲', currency: 'USD' },
  { code: 'DO', name: 'Доминиканская Республика', flag: '🇩🇴', currency: 'USD' },
  { code: 'EG', name: 'Египет',              flag: '🇪🇬', currency: 'USD' },
  { code: 'ZM', name: 'Замбия',              flag: '🇿🇲', currency: 'USD' },
  { code: 'ZW', name: 'Зимбабве',            flag: '🇿🇼', currency: 'USD' },
  { code: 'IL', name: 'Израиль',             flag: '🇮🇱', currency: 'USD' },
  { code: 'IN', name: 'Индия',               flag: '🇮🇳', currency: 'INR' },
  { code: 'ID', name: 'Индонезия',           flag: '🇮🇩', currency: 'USD' },
  { code: 'JO', name: 'Иордания',            flag: '🇯🇴', currency: 'USD' },
  { code: 'IQ', name: 'Ирак',                flag: '🇮🇶', currency: 'USD' },
  { code: 'IR', name: 'Иран',                flag: '🇮🇷', currency: 'IRR' },
  { code: 'IE', name: 'Ирландия',            flag: '🇮🇪', currency: 'EUR' },
  { code: 'IS', name: 'Исландия',            flag: '🇮🇸', currency: 'EUR' },
  { code: 'ES', name: 'Испания',             flag: '🇪🇸', currency: 'EUR' },
  { code: 'IT', name: 'Италия',              flag: '🇮🇹', currency: 'EUR' },
  { code: 'YE', name: 'Йемен',               flag: '🇾🇪', currency: 'USD' },
  { code: 'CV', name: 'Кабо-Верде',          flag: '🇨🇻', currency: 'USD' },
  { code: 'KZ', name: 'Казахстан',           flag: '🇰🇿', currency: 'KZT' },
  { code: 'KH', name: 'Камбоджа',            flag: '🇰🇭', currency: 'USD' },
  { code: 'CM', name: 'Камерун',             flag: '🇨🇲', currency: 'USD' },
  { code: 'CA', name: 'Канада',              flag: '🇨🇦', currency: 'CAD' },
  { code: 'QA', name: 'Катар',               flag: '🇶🇦', currency: 'USD' },
  { code: 'KE', name: 'Кения',               flag: '🇰🇪', currency: 'USD' },
  { code: 'CY', name: 'Кипр',                flag: '🇨🇾', currency: 'EUR' },
  { code: 'KG', name: 'Кыргызстан',          flag: '🇰🇬', currency: 'KGS' },
  { code: 'KI', name: 'Кирибати',            flag: '🇰🇮', currency: 'USD' },
  { code: 'CN', name: 'Китай',               flag: '🇨🇳', currency: 'CNY' },
  { code: 'CO', name: 'Колумбия',            flag: '🇨🇴', currency: 'USD' },
  { code: 'KM', name: 'Коморы',              flag: '🇰🇲', currency: 'USD' },
  { code: 'CG', name: 'Конго',               flag: '🇨🇬', currency: 'USD' },
  { code: 'CD', name: 'Конго (ДРК)',         flag: '🇨🇩', currency: 'USD' },
  { code: 'KP', name: 'КНДР',                flag: '🇰🇵', currency: 'USD' },
  { code: 'KR', name: 'Корея (Южная)',       flag: '🇰🇷', currency: 'KRW' },
  { code: 'XK', name: 'Косово',              flag: '🏳️', currency: 'EUR' },
  { code: 'CR', name: 'Коста-Рика',          flag: '🇨🇷', currency: 'USD' },
  { code: 'CI', name: 'Кот-д’Ивуар',         flag: '🇨🇮', currency: 'USD' },
  { code: 'CU', name: 'Куба',                flag: '🇨🇺', currency: 'USD' },
  { code: 'KW', name: 'Кувейт',              flag: '🇰🇼', currency: 'USD' },
  { code: 'LA', name: 'Лаос',                flag: '🇱🇦', currency: 'USD' },
  { code: 'LV', name: 'Латвия',              flag: '🇱🇻', currency: 'EUR' },
  { code: 'LS', name: 'Лесото',              flag: '🇱🇸', currency: 'USD' },
  { code: 'LR', name: 'Либерия',             flag: '🇱🇷', currency: 'USD' },
  { code: 'LB', name: 'Ливан',               flag: '🇱🇧', currency: 'USD' },
  { code: 'LY', name: 'Ливия',               flag: '🇱🇾', currency: 'USD' },
  { code: 'LT', name: 'Литва',               flag: '🇱🇹', currency: 'EUR' },
  { code: 'LI', name: 'Лихтенштейн',         flag: '🇱🇮', currency: 'USD' },
  { code: 'LU', name: 'Люксембург',          flag: '🇱🇺', currency: 'EUR' },
  { code: 'MU', name: 'Маврикий',            flag: '🇲🇺', currency: 'USD' },
  { code: 'MR', name: 'Мавритания',          flag: '🇲🇷', currency: 'USD' },
  { code: 'MG', name: 'Мадагаскар',          flag: '🇲🇬', currency: 'USD' },
  { code: 'MO', name: 'Макао',               flag: '🇲🇴', currency: 'USD' },
  { code: 'MK', name: 'Северная Македония',  flag: '🇲🇰', currency: 'EUR' },
  { code: 'MW', name: 'Малави',              flag: '🇲🇼', currency: 'USD' },
  { code: 'MY', name: 'Малайзия',            flag: '🇲🇾', currency: 'USD' },
  { code: 'ML', name: 'Мали',                flag: '🇲🇱', currency: 'USD' },
  { code: 'MV', name: 'Мальдивы',            flag: '🇲🇻', currency: 'USD' },
  { code: 'MT', name: 'Мальта',              flag: '🇲🇹', currency: 'EUR' },
  { code: 'MA', name: 'Марокко',             flag: '🇲🇦', currency: 'USD' },
  { code: 'MX', name: 'Мексика',             flag: '🇲🇽', currency: 'MXN' },
  { code: 'MZ', name: 'Мозамбик',            flag: '🇲🇿', currency: 'USD' },
  { code: 'MD', name: 'Молдова',             flag: '🇲🇩', currency: 'MDL' },
  { code: 'MC', name: 'Монако',              flag: '🇲🇨', currency: 'EUR' },
  { code: 'MN', name: 'Монголия',            flag: '🇲🇳', currency: 'USD' },
  { code: 'MM', name: 'Мьянма',              flag: '🇲🇲', currency: 'USD' },
  { code: 'NA', name: 'Намибия',             flag: '🇳🇦', currency: 'USD' },
  { code: 'NR', name: 'Науру',               flag: '🇳🇷', currency: 'USD' },
  { code: 'NP', name: 'Непал',               flag: '🇳🇵', currency: 'INR' },
  { code: 'NE', name: 'Нигер',               flag: '🇳🇪', currency: 'USD' },
  { code: 'NG', name: 'Нигерия',             flag: '🇳🇬', currency: 'USD' },
  { code: 'NL', name: 'Нидерланды',          flag: '🇳🇱', currency: 'EUR' },
  { code: 'NI', name: 'Никарагуа',           flag: '🇳🇮', currency: 'USD' },
  { code: 'NZ', name: 'Новая Зеландия',      flag: '🇳🇿', currency: 'NZD' },
  { code: 'NO', name: 'Норвегия',            flag: '🇳🇴', currency: 'NOK' },
  { code: 'AE', name: 'ОАЭ',                 flag: '🇦🇪', currency: 'AED' },
  { code: 'OM', name: 'Оман',                flag: '🇴🇲', currency: 'USD' },
  { code: 'PK', name: 'Пакистан',            flag: '🇵🇰', currency: 'PKR' },
  { code: 'PW', name: 'Палау',               flag: '🇵🇼', currency: 'USD' },
  { code: 'PS', name: 'Палестина',           flag: '🇵🇸', currency: 'USD' },
  { code: 'PA', name: 'Панама',              flag: '🇵🇦', currency: 'USD' },
  { code: 'PG', name: 'Папуа — Новая Гвинея',flag: '🇵🇬', currency: 'USD' },
  { code: 'PY', name: 'Парагвай',            flag: '🇵🇾', currency: 'USD' },
  { code: 'PE', name: 'Перу',                flag: '🇵🇪', currency: 'USD' },
  { code: 'PL', name: 'Польша',              flag: '🇵🇱', currency: 'PLN' },
  { code: 'PT', name: 'Португалия',          flag: '🇵🇹', currency: 'EUR' },
  { code: 'PR', name: 'Пуэрто-Рико',         flag: '🇵🇷', currency: 'USD' },
  { code: 'RU', name: 'Россия',              flag: '🇷🇺', currency: 'RUB' },
  { code: 'RW', name: 'Руанда',              flag: '🇷🇼', currency: 'USD' },
  { code: 'RO', name: 'Румыния',             flag: '🇷🇴', currency: 'RON' },
  { code: 'SV', name: 'Сальвадор',           flag: '🇸🇻', currency: 'USD' },
  { code: 'WS', name: 'Самоа',               flag: '🇼🇸', currency: 'USD' },
  { code: 'SM', name: 'Сан-Марино',          flag: '🇸🇲', currency: 'EUR' },
  { code: 'ST', name: 'Сан-Томе и Принсипи', flag: '🇸🇹', currency: 'USD' },
  { code: 'SA', name: 'Саудовская Аравия',   flag: '🇸🇦', currency: 'SAR' },
  { code: 'SZ', name: 'Эсватини',            flag: '🇸🇿', currency: 'USD' },
  { code: 'SC', name: 'Сейшелы',             flag: '🇸🇨', currency: 'USD' },
  { code: 'SN', name: 'Сенегал',             flag: '🇸🇳', currency: 'USD' },
  { code: 'RS', name: 'Сербия',              flag: '🇷🇸', currency: 'EUR' },
  { code: 'SG', name: 'Сингапур',            flag: '🇸🇬', currency: 'SGD' },
  { code: 'SY', name: 'Сирия',               flag: '🇸🇾', currency: 'USD' },
  { code: 'SK', name: 'Словакия',            flag: '🇸🇰', currency: 'EUR' },
  { code: 'SI', name: 'Словения',            flag: '🇸🇮', currency: 'EUR' },
  { code: 'US', name: 'США',                 flag: '🇺🇸', currency: 'USD' },
  { code: 'SB', name: 'Соломоновы Острова',  flag: '🇸🇧', currency: 'USD' },
  { code: 'SO', name: 'Сомали',              flag: '🇸🇴', currency: 'USD' },
  { code: 'SD', name: 'Судан',               flag: '🇸🇩', currency: 'USD' },
  { code: 'SR', name: 'Суринам',             flag: '🇸🇷', currency: 'USD' },
  { code: 'SL', name: 'Сьерра-Леоне',        flag: '🇸🇱', currency: 'USD' },
  { code: 'TJ', name: 'Таджикистан',         flag: '🇹🇯', currency: 'TJS' },
  { code: 'TH', name: 'Таиланд',             flag: '🇹🇭', currency: 'USD' },
  { code: 'TW', name: 'Тайвань',             flag: '🇹🇼', currency: 'USD' },
  { code: 'TZ', name: 'Танзания',            flag: '🇹🇿', currency: 'USD' },
  { code: 'TG', name: 'Того',                flag: '🇹🇬', currency: 'USD' },
  { code: 'TO', name: 'Тонга',               flag: '🇹🇴', currency: 'USD' },
  { code: 'TT', name: 'Тринидад и Тобаго',   flag: '🇹🇹', currency: 'USD' },
  { code: 'TV', name: 'Тувалу',              flag: '🇹🇻', currency: 'USD' },
  { code: 'TN', name: 'Тунис',               flag: '🇹🇳', currency: 'USD' },
  { code: 'TM', name: 'Туркменистан',        flag: '🇹🇲', currency: 'TMT' },
  { code: 'TR', name: 'Турция',              flag: '🇹🇷', currency: 'TRY' },
  { code: 'UG', name: 'Уганда',              flag: '🇺🇬', currency: 'USD' },
  { code: 'UZ', name: 'Узбекистан',          flag: '🇺🇿', currency: 'UZS' },
  { code: 'UA', name: 'Украина',             flag: '🇺🇦', currency: 'UAH' },
  { code: 'UY', name: 'Уругвай',             flag: '🇺🇾', currency: 'USD' },
  { code: 'FO', name: 'Фарерские острова',   flag: '🇫🇴', currency: 'USD' },
  { code: 'FJ', name: 'Фиджи',               flag: '🇫🇯', currency: 'USD' },
  { code: 'PH', name: 'Филиппины',           flag: '🇵🇭', currency: 'USD' },
  { code: 'FI', name: 'Финляндия',           flag: '🇫🇮', currency: 'EUR' },
  { code: 'FR', name: 'Франция',             flag: '🇫🇷', currency: 'EUR' },
  { code: 'HR', name: 'Хорватия',            flag: '🇭🇷', currency: 'EUR' },
  { code: 'TD', name: 'Чад',                 flag: '🇹🇩', currency: 'USD' },
  { code: 'ME', name: 'Черногория',          flag: '🇲🇪', currency: 'EUR' },
  { code: 'CZ', name: 'Чехия',               flag: '🇨🇿', currency: 'CZK' },
  { code: 'CL', name: 'Чили',                flag: '🇨🇱', currency: 'USD' },
  { code: 'CH', name: 'Швейцария',           flag: '🇨🇭', currency: 'CHF' },
  { code: 'SE', name: 'Швеция',              flag: '🇸🇪', currency: 'SEK' },
  { code: 'LK', name: 'Шри-Ланка',           flag: '🇱🇰', currency: 'INR' },
  { code: 'EC', name: 'Эквадор',             flag: '🇪🇨', currency: 'USD' },
  { code: 'GQ', name: 'Экваториальная Гвинея', flag: '🇬🇶', currency: 'USD' },
  { code: 'ER', name: 'Эритрея',             flag: '🇪🇷', currency: 'USD' },
  { code: 'EE', name: 'Эстония',             flag: '🇪🇪', currency: 'EUR' },
  { code: 'ET', name: 'Эфиопия',             flag: '🇪🇹', currency: 'USD' },
  { code: 'ZA', name: 'ЮАР',                 flag: '🇿🇦', currency: 'USD' },
  { code: 'SS', name: 'Южный Судан',         flag: '🇸🇸', currency: 'USD' },
  { code: 'JM', name: 'Ямайка',              flag: '🇯🇲', currency: 'USD' },
  { code: 'JP', name: 'Япония',              flag: '🇯🇵', currency: 'JPY' },
];

// Отсортированный по русскому алфавиту
export const COUNTRIES_SORTED = [...COUNTRIES].sort((a, b) =>
  a.name.localeCompare(b.name, 'ru')
);

// Хелпер: найти страну по коду
export function getCountry(code) {
  return COUNTRIES.find(c => c.code === code) || { code: code || 'KG', name: code || 'KG', flag: '🏳️' };
}
